import React from 'react'
import PropTypes from 'prop-types'

import {Badge, Stack} from '@salesforce/retail-react-app/app/components/shared/ui'

const TextBadges = ({product}) => {
    const textBadges = product?.c_textBadges

    if (!textBadges || textBadges.length === 0) {
        return null
    }
    const hasGivesBack = textBadges?.some((b) => b.includes('gives-back-text'))
    return (
        <Stack gap="0" marginBottom="10px" className="text-badge-wrapper">
            {(product?.c_badge || product?.representedProduct?.c_badge) && hasGivesBack && (
                <Badge
                    variant="textBadge"
                    className="text-badge-gives-back"
                    whiteSpace="normal"
                    dangerouslySetInnerHTML={{
                        __html: product?.c_badge || product?.representedProduct?.c_badge
                    }}
                />
            )}
            {textBadges.map((badge, index) => (
                <Badge
                    className="text-badge"
                    key={index}
                    variant="textBadge"
                    dangerouslySetInnerHTML={{__html: badge}}
                />
            ))}
        </Stack>
    )
}

TextBadges.propTypes = {
    product: PropTypes.shape({
        c_textBadges: PropTypes.arrayOf(PropTypes.string),
        c_badge: PropTypes.any,
        representedProduct: PropTypes.shape({
            c_badge: PropTypes.any
        })
    })
}

export default TextBadges
